<script>
    export let text;
</script>
<label {...$$props}>{@html text}</label>